<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">Autorizaciones</div>
            </div>
            <div class="alignIcon bold">BJ_01_Autorizaciones</div>
          </div>

          <div class="flxDivs">
            <div class="div20">
              <b-form-group label="Clínica" class="mginTop10">
                <v-select
                  class="mginTop10"
                  :clearable="false"
                  :options="listaClinicas"
                  v-model="cliId"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Selecciona una clínica"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="div80">
              <b-skeleton-table
                :rows="5"
                :columns="5"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="arrayTraspasos.length != 0">
                <b-table
                  thead-tr-class="columnas"
                  responsive
                  striped
                  hover
                  :items="arrayTraspasos"
                  v-if="arrayTraspasos.length != 0 && cargandoTabla == false"
                >
                  <template #cell(Autorizaciones)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalle(row.item)"
                      v-if="
                        $localStorageService.can('BJ_02_autozaciones_detalle')
                      "
                    >
                      <em class="fa fa-info-circle"></em>
                    </b-button>
                  </template>

                  <template #cell(Detalle)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalleCard(row.item.Folio)"
                    >
                      <em class="fa fa-eye"></em>
                    </b-button>
                  </template>
                  <template #cell(Documentos)="row">
                    <span v-if="row.item.Documentos.length != 0">
                      <span
                        v-for="imagen in row.item.Documentos"
                        v-bind:key="imagen"
                      >
                        <b-icon
                          icon="download"
                          v-b-tooltip.hover.top="'Descargar'"
                          @click="
                            downloadImage(
                              imagen.imagen,
                              row.item.Folio,
                              imagen.tipo
                            )
                          "
                          class="pointer"
                        ></b-icon>
                        <br />
                        <br />
                      </span>
                    </span>
                    <span v-else class="grayTxt"> Sin documentos </span>
                  </template>
                  <template #cell(Rechazar)="row">
                    <b-button
                      variant="primary"
                      @click="
                        abrirDetalleRechazo(row.item.Folio, 3, row.item.Monto)
                      "
                    >
                      <em class="fa fa-times-circle"></em>
                    </b-button>
                  </template>
                </b-table>
                <br />
                <br />
              </span>
              <strong
                v-if="arrayTraspasos.length == 0 && cargandoTabla == false"
                >Sin solicitudes</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-detalle" hide-footer>
      <template #modal-title>Autorizaciones</template>
      <div class="d-block text-left">
        <b-form-checkbox
          v-for="item in autorizacionesArray"
          :key="item.idTraspasoAutorizacion"
          switch
          name="check-button"
          v-model="item.autorizado"
          class="mginCheckCss"
          :disabled="
            idUsuario != item.usuarioPermiso || item.autorizado == true
          "
          @change="actualizarAutorizacion(item)"
        >
          {{ item.nombreAutorizacion }}
        </b-form-checkbox>

        <br />

        <!-- <b-form-group
          label="Especifica la razón por la cual rechazas la modificación"
          class="mginTop10"
        >
          <b-form-textarea
            v-model="razon"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group> -->
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-detalle')"
        >Cerrar</b-button
      >
    </b-modal>

    <b-modal id="modal-detalle-card" hide-footer>
      <template #modal-title>Movimiento de saldo</template>
      <div class="d-block text-left">
        <p><strong>Folio: </strong>{{ info.folio }}</p>
        <p><strong>Fecha de solicitud: </strong>{{ info.fecha }}</p>
        <p><strong>Clínica: </strong>{{ info.clinica }}</p>
        <p><strong>Solicitante: </strong>{{ info.solicitante }}</p>
        <p><strong>Nombre del paciente: </strong>{{ info.nombreP }}</p>
        <p><strong>Saldo: </strong>{{ info.saldoA }}</p>
        <p><strong>Saldo actual: </strong>{{ info.saldoActual }}</p>
        <p><strong>Razón del moviento: </strong>{{ info.razon }}</p>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-detalle-card')"
        >Cerrar</b-button
      >
    </b-modal>
    <b-modal id="modal-detalle-rechazo" hide-footer>
      <template #modal-title>Rechazo de modificación de saldo</template>
      <div class="d-block text-left">
        <b-form-group
          label="Especifica la razón por la cual rechazas la modificación"
          class="mginTop10"
        >
          <b-form-textarea
            v-model="razon"
            rows="3"
            max-rows="6"
          ></b-form-textarea>

          <br />

          <b-form-group label="Motivo Rechazo">
            <b-form-select
              v-model="status"
              :options="opcionesEstatus"
            ></b-form-select>
          </b-form-group>
        </b-form-group>
        <b-button
          variant="outline-primary"
          :disabled="razon == null"
          @click="actualizarEstatus(folio, status, razon, monto)"
        >
          Guardar
        </b-button>
      </div>
      <b-button
        class="mt-3"
        block
        @click="$bvModal.hide('modal-detalle-rechazo')"
        >Cerrar</b-button
      >
    </b-modal>
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";

export default {
  name: "bandejaAutorizaciones",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    cliId: null,
    listaClinicas: [],
    cargandoTabla: false,
    arrayTraspasos: [],
    info: {},
    estatusId: null,
    loading: false,
    folio: null,
    status: null,
    razon: null,
    autorizacionesArray: [],
    idUsuario: null,
    currentTraspaso: null,
    listaMovimientos: [],
    opcionesEstatus: [
      {
        value: 3,
        text: "RECHAZAR",
      },
      {
        value: 6,
        text: "EQUIVOCACIÓN",
      },
      {
        value: 7,
        text: "MODIFICACIÓN",
      },
      {
        value: 8,
        text: "IMPORTE INCORRECTO",
      },
    ],
  }),
  mounted() {
    this.idUsuario = this.$localStorageService.getIdUsuario(); //HARDCODE Prueba
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.llenarClinicas();
    this.cliId = this.$localStorageService.getIdClinica();
    this.ObtenerTraspasos(this.$localStorageService.getIdClinica());
  },
  methods: {
    actualizarEstatus(folio, estatusId, mensaje, monto) {
      this.$swal
        .fire({
          title: "¿Estás seguro de actualizar el estatus?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loading = true;
            this.$http
              .put(
                this.$api +
                  "saldo/actualizarTraspaso?idEstatusTraspaso=" +
                  estatusId +
                  "&idTraspaso=" +
                  folio +
                  "&idUsuario=" +
                  this.$localStorageService.getIdUsuario() +
                  "&comentario=" +
                  mensaje +
                  "&monto=" +
                  monto
              )
              .then(() => {
                this.ObtenerTraspasos();
              })
              .catch((error) => {
                console.error(error);
                this.banderaBtn = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error",
                });
              })
              .finally(() => {
                this.loading = false;
                location.reload();
              });
          },
        })
        .then((result) => {
          if (result.value) {
            this.$swal({
              icon: "success",
              title: "Se actualizó correctamente",
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$bvModal.hide("modal-detalle-rechazo");
              },
            });
          }
        });
    },
    abrirDetalleRechazo(folio, status, monto) {
      this.folio = folio;
      this.monto = monto;
      this.status = status;
      this.$bvModal.show("modal-detalle-rechazo");
    },
    downloadImage(blobImage, id, tipo) {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:" + tipo + ";base64," + blobImage; //Image Base64 Goes here
      a.download = id; //File name Here
      a.click(); //Downloaded file
    },
    abrirDetalleCard(idFolio) {
      var datos = this.listaMovimientos.filter(
        (item) => item.idTraspaso == idFolio
      );

      this.$bvModal.show("modal-detalle-card");
      this.info = {
        folio: datos[0]["idTraspaso"],
        fecha: this.$moment(datos[0].fechaAlta).utc().format("DD/MM/YYYY"),
        clinica: datos[0]["clinicaNombre"],
        solicitante: datos[0]["solicitanteNombre"],
        nombreP: datos[0]["pacienteNombre"],
        saldoA: datos[0]["monto"],
        saldoActual: datos[0]["saldoActual"],
        razon: datos[0]["comentarioMovimiento"],
      };
    },

    actualizarAutorizacion(data) {
      this.$http
        .put(
          this.$api +
            "saldo/actualizarAutorizacion?idTraspaso=" +
            this.currentTraspaso +
            "&idTraspasoAutorizacion=" +
            data.idTraspasoAutorizacion +
            "&idUsuario=" +
            this.$localStorageService.getIdUsuario() +
            "&bandera=" +
            true
        )
        .then(() => {
          setTimeout(() => location.reload(), 1500);
        })
        .catch((error) => {
          console.error(error);
          this.banderaBtn = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Error",
          });
        });
    },
    abrirDetalle(itemDetalle) {
      this.autorizacionesArray = itemDetalle.Autorizaciones;
      this.currentTraspaso = itemDetalle.Folio;
      this.$bvModal.show("modal-detalle");
    },
    llenarClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((response) => {
          if (response.status === 200) {
            this.listaClinicas = response.data.data
              .map((it) => {
                return {
                  id: it.idClinica,
                  nombre: it.strNombre,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

            this.listaClinicas.push({ id: null, nombre: "TODAS" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    ObtenerTraspasos(idClinica) {
      this.arrayTraspasos = [];
      this.cargandoTabla = true;
      this.$http
        .get(
          this.$api + "saldo/obtenerMovimientosPorEstatus?idEstatusTraspaso=4",
          {
            params: {
              idClinica: idClinica,
            },
          }
        )
        .then((response) => {
          this.cargandoTabla = false;
          if (response.status === 200) {
            this.arrayTraspasos = response.data.data.map((it) => {
              if (it.autorizaciones != null) {
                it.autorizaciones.forEach((element) => {
                  element.usuarioPermiso =
                    element.usuarioPermiso != null ? element.usuarioPermiso : 0;
                });
              }

              return {
                Folio: it.idTraspaso,
                Clínica: it.clinicaNombre,
                Paciente: it.pacienteNombre,
                Monto: it.monto,
                Autorizaciones: it.autorizaciones,
                Detalle: true,
                Documentos: it.imagenesTraspaso,
                Rechazar: true,
              };
            });
            this.listaMovimientos = response.data.data;
          }
        })
        .catch((error) => {
          this.cargandoTabla = false;
          console.error(error);
        });
    },
  },
  watch: {
    cliId: function () {
      this.ObtenerTraspasos(this.cliId);
    },
  },
};
</script>
<style scoped>
.inputIconDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title_hist {
  font-weight: bolder;
  font-size: 25px;
  color: #053672;
}

.colorInfo {
  color: #ffc107;
}

.info {
  margin-top: 10px;
  background-color: #fff87c;
  border: 2px solid #fbb917;
  padding: 10px;
  border-radius: 10px;
}

.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div20 {
  width: 25%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.div80 {
  width: 73%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.txtCard {
  padding-left: 16px !important;
}

.mginCheckCss {
  margin-top: 10px;
}

.grayTxt {
  color: gray;
}
</style>
